
import {
  Component,
  Vue
} from 'vue-property-decorator'
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue'
import {
  Printd
} from 'printd'
@Component({
  name: 'FDAPrint',
  components: {
    VueAutonumeric
  }
})
export default class FDAPrint extends Vue {
    protected showComponent = false
    protected document: any = null
    protected fda: any = {
      id: null,
      client: {},
      company: {},
      job: {},
      fda_date: null,
      description: null,
      payment_method: null,
      currency: null,
      company_address: null,
      client_address: null,
      bank_account: {},
      items: [],
      oil_quantity: null,
      water_quantity: null,
      total_oil_water_quantity: null,
      sub_total: null,
      advance_received: null,
      total: null,
      memorandum: null,
      remark: null,
      status: null,
      created_user: null,
      modified_user: null
    }

    protected styles = ['https://api.smc-spl-application.com/print.css']

    get TotalQty () {
      const oil = Number(this.fda.oil_quantity)
      const water = Number(this.fda.water_quantity)

      if (isNaN(oil) || isNaN(water)) return ''
      return oil + water
    }

    protected populateFDA (obj) {
      this.fda = obj

      this.fda.items = obj.items.map(line => ({
        ...line,
        isEdit: false,
        item: {
          id: line.item_id,
          name: line.item_name,
          description: line.description
        },
        tariffs: []
      }))
    }

    public show (document: any) {
      this.showComponent = true

      this.populateFDA(document)

      this.document = new Printd()

      this.$nextTick(() => {
        this.print()
      })
    }

    protected print () {
      this.document.print(document.getElementById('printFDA'), this.styles)
    }

    public hide () {
      this.cancel()
      this.showComponent = false
    }

    public cancel () {
      this.reset(this.fda)
    }

    protected reset (obj: any) {
      for (const key in obj) {
        obj[key] = null
      }
    }
}
